import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ConversationList = ({ conversations, selectedConversation, onSelectConversation, currentUserId }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const formatTime = (date) => {
    const messageDate = new Date(date);
    const now = new Date();
    const diffInHours = (now - messageDate) / (1000 * 60 * 60);

    if (diffInHours < 24) {
      return messageDate?.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
    } else if (diffInHours < 48) {
      return 'Yesterday';
    } else {
      return messageDate?.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric' 
      });
    }
  };

  const filteredConversations = conversations?.filter(conv => 
    conv?.otherParticipant?.full_name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  ) || [];

  return (
    <>
      <div className="p-4 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground mb-3">Messages</h2>
        <div className="relative">
          <Icon 
            name="Search" 
            size={18} 
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" 
          />
          <input
            type="text"
            placeholder="Search conversations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            className="w-full pl-10 pr-4 py-2 bg-muted border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {filteredConversations?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full p-8 text-center">
            <Icon name="MessageSquare" size={48} className="text-muted-foreground opacity-30 mb-4" />
            <p className="text-muted-foreground">
              {searchQuery ? 'No conversations found' : 'No conversations yet'}
            </p>
          </div>
        ) : (
          filteredConversations?.map((conversation) => (
            <button
              key={conversation?.id}
              onClick={() => onSelectConversation(conversation)}
              className={`
                w-full p-4 flex items-start gap-3 hover:bg-muted transition-smooth border-b border-border
                ${selectedConversation?.id === conversation?.id ? 'bg-muted' : ''}
              `}
            >
              <div className="relative flex-shrink-0">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-muted">
                  <Image 
                    src={conversation?.otherParticipant?.avatar_url || '/assets/images/no_image.png'} 
                    alt={`${conversation?.otherParticipant?.full_name || 'User'} avatar`}
                    className="w-full h-full object-cover"
                  />
                </div>
                {conversation?.unreadCount > 0 && (
                  <div className="absolute -top-1 -right-1 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                    <span className="text-xs font-bold text-primary-foreground">
                      {conversation?.unreadCount > 9 ? '9+' : conversation?.unreadCount}
                    </span>
                  </div>
                )}
              </div>
              
              <div className="flex-1 min-w-0 text-left">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-semibold text-foreground truncate">
                    {conversation?.otherParticipant?.full_name || 'Unknown User'}
                  </h3>
                  <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
                    {formatTime(conversation?.lastMessageTime)}
                  </span>
                </div>
                
                <div className="flex items-center gap-2">
                  {conversation?.otherParticipant?.role && (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary capitalize flex-shrink-0">
                      {conversation?.otherParticipant?.role}
                    </span>
                  )}
                  <p className="text-sm text-muted-foreground truncate flex-1">
                    {conversation?.lastMessage || 'No messages yet'}
                  </p>
                </div>
              </div>
            </button>
          ))
        )}
      </div>
    </>
  );
};

export default ConversationList;